import Drag from '../../content/Drag';
import HeroPuzzle from '../../content/Drag/Hero/HeroPuzzle';

export default function initDraggables() {
  const Hero = new HeroPuzzle(document.getElementById('Hero'));
  Hero.init();

  Drag.Hero(HeroPuzzle, Hero);
  Drag.Basics();
  Drag.Swappable();
  Drag.Sortable();
  Drag.Collidable();
}
